<template>
  <div>
    <link
      href="https://cdn.staticfile.org/quill/1.3.6/quill.core.css"
      rel="stylesheet"
    />
    <div class="se-main se-flex">
      <div class="se-left">
        <el-menu
          class="el-menu-vertical-demo"
          :default-active="type"
          active-text-color="#E42335"
          @select="menuSelect"
        >
          <el-menu-item index="1">
            <div class="se-flex aic jcc">
              <span class="se-m-r-10">通知消息</span>
              <div
                :class="[
                  'se-circle',
                  'ft-14-fe-b',
                  count1 === 0 ? 'opc-0' : '',
                ]"
              >
                {{ count1 }}
              </div>
            </div>
          </el-menu-item>
          <el-menu-item index="2">
            <div class="se-flex aic jcc">
              <span class="se-m-r-10">系统消息</span>
              <div
                :class="[
                  'se-circle',
                  'ft-14-fe-b',
                  count2 === 0 ? 'opc-0' : '',
                ]"
              >
                {{ count2 }}
              </div>
            </div>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="se-right">
        <div v-if="type === '1'">
          <div v-show="step === 'title'" class="se-list">
            <div
              class="se-item se-flex jcsb se-p-t-30 se-p-b-30 se-bor-b cp"
              v-for="(v, i) in msg"
              :key="i"
              @click="showContent(v, 'updateMessage')"
            >
              <el-badge is-dot :hidden="!!v.hasRead" class="item">
                <div class="ft-14-000">
                  {{ v.title }}
                </div>
              </el-badge>
              <div class="ft-14-999">{{ v.createdTime }}</div>
            </div>
          </div>
          <div v-show="step === 'content'">
            <div
              class="se-p-t-30 se-bor-b se-p-b-25"
              style="border-bottom: 1px solid #c0c4cc"
            >
              <div class="ft-18-333 se-m-b-20">{{ info.title }}</div>
              <div class="ft-14-999">{{ info.createdTime }}</div>
            </div>
            <div class="se-p-t-30 ql-editor" v-html="info.content"></div>
          </div>
        </div>
        <div v-if="type === '2'">
          <div v-show="step === 'title'" class="se-list">
            <div
              class="se-item se-flex jcsb se-p-t-30 se-p-b-30 se-bor-b cp"
              v-for="(v, i) in sysMsg"
              :key="i"
              @click="showContent(v, 'updateinformMessage')"
            >
              <el-badge is-dot :hidden="!!v.hasRead" class="item">
                <div class="ft-14-000 se-flex">
                  {{ v.content }}
                  <div v-if="v.content" class="se-m-l-5">,前往查看>>></div>
                </div>
              </el-badge>

              <div class="ft-14-999">{{ v.createdTime }}</div>
            </div>
          </div>
          <div v-show="step === 'content'">
            <div class="se-p-t-30 se-bor-b se-p-b-25">
              <div class="ft-18-333 se-m-b-20">
                {{ info.title }}
              </div>
              <div class="ft-14-999">{{ info.createdTime }}</div>
            </div>
            <div class="se-p-t-30 ql-editor" v-html="info.content"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="step !== 'content'" class="se-flex-h-c se-m-t-20">
      <el-pagination
        background
        @current-change="currentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "1",
      count1: 0,
      count2: 0,
      step: "title",
      msg: [],
      sysMsg: [],
      info: {},
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },

  created() {
    // this.getNews();
    this.getMsg();
    this.getSysMsg();
    // if (this.$route.query.type) this.step = this.$route.query.type;
  },

  methods: {
    // async getNews() {
    //   const msg = await this.$http.get("server/portal/message/messageList");
    //   const sysMsg = await this.$http.get(
    //     "server/portal/message/informMessageList"
    //   );
    //   this.msg = msg.rows;
    //   this.sysMsg = sysMsg.rows;
    //   if (msg.rows.length !== 0) {
    //     this.count1 = this.msg.filter((s) => s.hasRead === 0).length;
    //   }
    //   if (sysMsg.rows.length !== 0) {
    //     this.count2 = this.sysMsg.filter((s) => s.hasRead === 0).length;
    //   }
    // },
    async getMsg() {
      const res = await this.$http.get("server/portal/message/messageList", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      this.total = res.data.total;
      this.msg = res.data.messageVos;
      this.count1 = res.data.messageCount;
    },

    async getSysMsg() {
      const res = await this.$http.get(
        "server/portal/message/informMessageList",
        {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
      );
      this.total = res.data.total;
      this.sysMsg = res.data.messageVos;
      this.count2 = res.data.messageCount;
    },
    //   菜单选择回调
    menuSelect(e) {
      // let path = this.$router.history.current.path;
      // this.$router.push({
      //   path,
      //   query: {},
      // });
      this.pageNum = 1;
      if (e === "1") {
        this.getMsg();
      } else {
        this.getSysMsg();
      }
      this.type = e;
      this.step = "title";
    },

    // 展示消息内容
    async showContent(info, url) {
      // console.log(info, "info");
      await this.$http.put(`server/portal/message/${url}/${info.id}`);
      await this.$store.dispatch("setReadCount");

      if (url === "updateMessage") {
        // let path = this.$router.history.current.path;
        // this.$router.push({
        //   path,
        //   query: { type: "content" },
        // });
        this.step = "content";
        this.info = info;
        var richtext = info.content;
        const regex = new RegExp("<img", "gi");
        this.info.content = richtext.replace(regex, '<img style="width:100%;"');
      } else {
        // console.log(url, "url");
        // console.log(info, "info");
        this.info = info;
        var richtext = info.content;
        const regex = new RegExp("<img", "gi");
        this.info.content = richtext.replace(regex, '<img style="width:100%;"');
        const goType = this.info.urlPath.split("&");
        if (goType[0] === "type=study") {
          const id = this.info.urlPath.split("&")[1].split("=")[1];
          // console.log(id, "id");
          this.$router.push({
            name: "courseInfo",
            query: { type: "study", planId: id },
          });
        } else if (goType[0] === "type=rchPlan") {
          this.$message.info("请在手机端企业微信中查看");
        } else {
          this.$router.push({
            name: "user",
            query: { defaultActive: 6, from: "sysMsg", id: info.urlPath },
          });
        }
      }
      if (this.type === "1") this.getMsg();
      if (this.type === "2") this.getSysMsg();
      // this.getNews();
    },

    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      if (this.type === "1") this.getMsg();
      if (this.type === "2") this.getSysMsg();
    },
  },
};
</script>

<style lang="scss" scoped>
.se-left {
  width: 240px;
  background-color: #f8fafc;
}

.se-right {
  flex: 1;
  padding: 6px 20px 0;
  background-color: #fff;
}

/deep/ .el-menu-item {
  text-align: center;
}

/deep/ .el-menu {
  border: none;
}

/deep/ .el-menu-item.is-active {
  background-color: #fff;
}

/deep/ .el-menu-item {
  background-color: #f8fafc;
}

.se-circle {
  width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 50%;
  background-color: #e44352;
  text-align: center;
}

.opc-0 {
  opacity: 0;
}

.se-item {
  align-items: center;
  .ft-14-999 {
    margin-left: 12px;
    white-space: nowrap;
  }
}

.se-main {
  min-height: 800px;
}
</style>
